import * as React from "react";
import { Button, Spinner, Input } from "@fluentui/react-components";
import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell } from "@fluentui/react-components";
import { useAuditSessions } from "../hooks/useAuditSessions";
import { formatDate } from "../utils/dates";

interface SessionSelectionDialogProps {
  onSessionSelected: (sessionId: string, sessionName: string) => void;
  onCancel: () => void;
}

export const SessionSelectionDialog: React.FC<SessionSelectionDialogProps> = ({ onSessionSelected }) => {
  const [searchQuery, setSearchQuery] = React.useState("");
  const { auditSessions, loading } = useAuditSessions();

  // Filter sessions based on search query
  const filteredSessions = React.useMemo(() => {
    if (!searchQuery) return auditSessions;
    const query = searchQuery.toLowerCase();
    return auditSessions.filter(
      (session) => session.name.toLowerCase().includes(query) || session.id.toLowerCase().includes(query)
    );
  }, [auditSessions, searchQuery]);

  return (
    <div className="flex flex-col gap-4 mx-auto max-w-xl px-4 py-6 h-screen bg-white">
      <div className="flex flex-col gap-4">
        <div className="text-lg font-semibold">Select a session</div>
        <Input placeholder="Search sessions" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />

        {loading ? (
          <div className="flex justify-center items-center">
            <Spinner />
          </div>
        ) : (
          <div className="max-h-[70vh] overflow-y-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHeaderCell>Name</TableHeaderCell>
                  <TableHeaderCell>Created At</TableHeaderCell>
                  <TableHeaderCell>Action</TableHeaderCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredSessions.map((session) => (
                  <TableRow key={session.id}>
                    <TableCell>{session.name}</TableCell>
                    <TableCell>{formatDate(session.createdAt)}</TableCell>
                    <TableCell>
                      <Button onClick={() => onSessionSelected(session.id, session.name)}>Select</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
};
